import React from 'react'
import PropTypes from 'prop-types'
import { css } from 'aphrodite'
import { Row, Col } from 'reactstrap'

import { descriptiveNumbers } from '../../../utils/strings'

import style from '../style'

export const Summary = props => {
  const date = {
    day: props.date.getUTCDate(),
    month: props.date.toLocaleString('en-US', {
      month: 'long',
      timeZone: 'UTC'
    }),
    year: props.date.getUTCFullYear()
  }

  return [
    <h3 key={0} className={css(style.headers.h3)}>
      Month Statistics - {date.month} {date.year}
    </h3>,
    <Row key={1} className={css(style.summary.wrapper)}>
      <Col
        xs="12"
        md="4"
        className={`d-flex flex-column align-items-center justify-content-center`}
      >
        <span className={css(style.summary.value)}>
          {descriptiveNumbers(props.stats.queries || 0)}
        </span>
        <span className={css(style.summary.label)}>Requests</span>
      </Col>
      <Col
        xs="12"
        md="4"
        className={`d-flex flex-column align-items-center justify-content-center`}
      >
        <span className={css(style.summary.value)}>
          {descriptiveNumbers(props.stats.impressions || 0)}
        </span>
        <span className={css(style.summary.label)}>Impressions</span>
      </Col>
      <Col
        xs="12"
        md="4"
        className={`d-flex flex-column align-items-center justify-content-center`}
      >
        <span className={css(style.summary.value)}>
          ${descriptiveNumbers(+props.stats.earnings || 0)}
        </span>
        <span className={css(style.summary.label)}>Earnings</span>
      </Col>
    </Row>
  ]
}

Summary.propTypes = {
  date: PropTypes.object.isRequired,
  stats: PropTypes.object.isRequired
}

export default Summary



// WEBPACK FOOTER //
// ./src/components/Statistics/partials/Summary.js